module.exports = __webpack_public_path__ + "img/bus_idle.aa2a9d52.svg";